import { render, staticRenderFns } from "./ProjectServiceChargeList.vue?vue&type=template&id=5bb1f1b9&"
import script from "./ProjectServiceChargeList.vue?vue&type=script&lang=js&"
export * from "./ProjectServiceChargeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports